jQuery(function($) {
	if ( !window.console ) console = {};
	if ( !console.error ) console.error=function(){};
	if ( !console.log ) console.log=function(){};
	if ( !console.warn ) console.warn=function(){};
	var grocerylist  =  (function(){
		var get  =  function () {
			var b,t="",gl="",dagen,menus,menu="",titles,new_day,old_day="",menu,ingredients,ingredient,grocerylist={aanwezig:{}};
			menus  =  $( '.dagmenu:not(.inactive) .weekrecept:not(.inactive)' );
			if ( !menus ) {
				return gl;
			}
	var day;
			menus.each(function(index,element){
				new_day  =  $( this );
				day  = new_day.parent().children( 'h1' ).text().replace( /:[^:]+$/ , '' );
				titles  =  new_day.find( '.recipetitle' );
				ingredients  =  new_day.children( '.ingredienten' );
				ingredients.each(function(index,element){
					menu  =  titles[ index ].innerHTML;
					ingredients  =  element.innerHTML.split( "<br>\n" );
					for ( index in ingredients ) {
						ingredient  =  ingredients[ index ];
						ingredient  =  ingredient.replace( /(?:•|o|●)\t(.*)/ , "$1" );
						ingredient  =  ingredient.replace( /&amp;/ , "&" );
						if ( !ingredient ) {
							console.warn(
								'Recept voor "'
								+ menu
								+ '" bevat witregels, worden die witregels gekookt of gebakken?'
							);
							continue;
						}
						var i=ingredient;
						ingredient  =  new RegExp( ''
							+ '^(?:'
								+ '('
									+ '(?:ca\\. )?'
									+ '(?:½'
									+ '|(?:(?:[1-9][0-9]*/)?[1-9][0-9]*)'
									+ '|(?:[1-9][0-9]*,[1-9][0-9]*)'
									+ '|(?:[1-9][0-9]*-[1-9][0-9]*)'//2-4 volkoren boterhammen,2-4 handjes ...
									+ ')'
									+ '(?: of (?:me|mind)er)?'
								+ ')'
							+ ' )?'
							+ '([A-Za-z]+'
	//						+ '([A-Za-z]+,?'// komma toont instructies in ingrediënten?
								+ '(?: \\([^'+/*(*/'\\)]+\\))?'// optioneel gevolgd door iets tussen haakjes
							+ ')(?: (.+))?$'
						).exec( ingredient );
						if ( !ingredient ) {// @todo remove (references to) var i
							console.error(
								'could not (yet) detect ingredient in: `' + i + '`.'
							);
							continue;
						}

						var aanwezig  =  new RegExp(
							'^(water|olie|zout|peper)(?: .*)?$'
							, 'i'
						);
						if ( null == ingredient[3] )
							var i3=null;
						else
							var i3=ingredient[3].match( aanwezig );
						var i2=ingredient[2].match( aanwezig );
						if ( null != i3 || null != i2 ) {
							var prop  =  ( null == i3 ? i2[1] : i3[1] ).toLowerCase();
							if ( !grocerylist.aanwezig.hasOwnProperty( prop ) )
								grocerylist.aanwezig[ prop ]  =  true;
							continue;
						}

						if (
							ingredient[0].match( /,|:|\\.|(?: (?:[^ ]+ ){6,})/ )
							|| ( ingredient[3] && ingredient[3].match( / (?:[^ ]+ ){3,}/ ) )
						) {
							console.warn( ''
								+ 'Script heeft komma, (dubbele) punt of veel spaties gevonden '
								+ '(suggereert aanwezige instructie of suggestie) '
								+ '\nin ingrediënt voor recept "'
								+ menu
								+ '"\n namelijk bij het ingrediënt: `'
								+ ingredient[0]
								+ '`'
							);
						}

						b  =  ingredient[2].match(
							new RegExp(
								"^(?:" + [
								"pot(?:jes?)?"
								, "blik(?:jes?|ken)?"
								, "(?:z|b)ak(?:jes?|ken)?"
								, "hand(?:je)?"
								, "teen(?:tjes?)?"
								, "doosje" , "beetje" , "snufje"
								, "el" , "eetlepel" , "eetlepels"
								, "tl" , "theelepel(?:\\(?s\\)?)?"
								, "ml" , "milliliter"
								, "liter" //, "l"
								, "gr" , "gram" , "g"/*:s*/
								, "kg" , "kilogram" , "kilo"
								].join( "|" )
								+ ")(?: \\([^\\)]+\\))?$"
								, "i"
							)
						);
						if ( null == b ) {
							if ( undefined == ingredient[3] ) {
								ingredient[3]  =  ingredient[2];
							} else {
								ingredient[3]  =  ingredient[2] + " " + ingredient[3];
							}
							ingredient[2]  =  "";
						}
						t = " _";
						t += ingredient[3];
						t += "_ ";
						if ( ingredient[1] )
							t += "-" + ingredient[1] + "- ";
						t += "^" + ingredient[2] + "^ ";
						var o  =  {
							type  :  ingredient[ 2 ] ,
							amount  :  ingredient[1] ,
							menu  :  menu ,
							date  :  day
						};
						console.log( ingredient[3] , o );
						if ( !grocerylist.hasOwnProperty( ingredient[3] ) ){
							grocerylist[ ingredient[3] ]  =  [o];
						} else {
							grocerylist[ ingredient[3] ].push(o);
						}
						//			t += element;
					}
				});
			});
			return grocerylist;
		};

		var printList = function () {
			gl = get();
			if ( !gl ) { return; }
			var gl2="",samen2="",type="",amount=0,amountX=false,tmpAmount,aannames={};
			aannames = gl.aanwezig;
			delete gl.aanwezig;
			var ingredientenTeller=0;
			$.each( gl , function ( index , value ) {
				samen2="",type="",amount=0,amountX=false;;
	// controleren en optellen hoeveelheden:
				$.each( value , function ( i , v ) {

	// al deze `vreemde` hoeveelheden worden 0.5
					if ( (v.amount+'').match(
						/(?:½|(?:[1-9][0-9]*\/[1-9][0-9]*))/
					) ) {
						v.amount  =  0.5;
					}
	//2-4 volkoren boterhammen,2-4 handjes ... Neem gemiddelde van gegeven bereik
					tmpAmount = /([1-9][0-9]*)-([1-9][0-9]*)/.exec( (v.amount+'') );
					if ( tmpAmount ) {
						v.amount  =  ( 1*tmpAmount[1] + 1*tmpAmount[2] ) / 2;
					}

					if ( type == "" ) {
						type  =  v.type;
					}
					if ( type == v.type ) {
						if ( !isNaN( 1*v.amount ) ) {
							amount += 1*v.amount;
						} else {
							amount++;
							amountX  =  true;
						}
					} else {
						// @todo: meervouden, verkleinwoorden etc.
						console.error(
							'at this point in time type: ' + type
							+ ' and v.type: ' + v.type + ' cannot be added'
							+ ' for ingredient: `' + index + '`.'
						);
					}
				});
				if ( 1 != amount ) {
					if ( 0.5 == (amount%1) ) {
						amount  =  Math.floor(amount);
						if ( 0 == amount )
							amount  =  '';
						amount += '½';
					}
					samen2 +=  amount
						+ ( amountX ? 'x ' : ' ' );
				}
				if ( type && undefined != type ) {
					samen2 +=  type + ' ';
				}
				if ( index && undefined != index ) {
					samen2 +=  index;
				}
				gl2 +=  samen2 + '<br />';
			});
			var a;
			for ( a in aannames ) {
				if ( aannames.hasOwnProperty( a ) ) {
					gl2 +=  '<br />Aangenomen dat ';
					for ( a in aannames ) {
						if ( 'water' == a ) a += '☺';
						gl2 += a + ', ';
					}
					gl2  =  ''
						+ gl2.substring(
							0 ,
							gl2.substring( 0 , gl2.length-2 ).lastIndexOf( ',' )
						)
						+ ' en ' + a + ' reeds aanwezig zijn.';
				}
				break;
			}

			var mywindow = window.open(
				'',
				'grocerylist',
				'height=400,width=600,dependent=yes,scrollbars=yes'
			);
			if ( !mywindow.document.body || '' == mywindow.document.body.innerHTML ) {
				mywindow.document.write( ''
					+ '<html><head><title>boodschappenlijstje</title>'
					+ '<style type="text/css" media="print">'
					+ 'input{display  :  none;}'
					+ '</style>'
	//				+ '<link rel="stylesheet" href="main.css" type="text/css" />');
					+ '</head><body>'
					+ '<h1 '
					+ '>Boodschappenlijstje'
					+ '<img alt="veganchallenge, daag jezelf uit" '
					+ 'src="/wp-content/themes/veganchallenge2/images/logo.png" '
					+ 'style="float  :  right; width  :  52mm;" '
					+ '/>'
					+ '</h1>'
					+ '</body></html>'
				);
			}
			var btn  =  ''
				+ '<input type="button" '
				+ 'onclick="window.print();window.close();" '
				+ 'value="print en sluit dit venster" '
				+ 'style="'
				+ 'float  :  right; '
				+ 'clear  :  right; '
				+ 'margin-top  :  2ex; '
				+ '" />'
			;
			mywindow.document.body.innerHTML +=  btn;
			mywindow.document.body.innerHTML +=  gl2;
			mywindow.document.body.innerHTML +=  btn;
	//		mywindow.print();
	//		mywindow.close();
		};
		return {
			print : printList
		};
	}());

	$(function() {
		// Bail out immediately if we're on the wrong page.
		// TODO: identify these elements by classes instead, and link them together using data attributes
		if (!$('#run').length || !$('#week-menu').length || !$('#week-list').length) {
			return;
		}

		// Note that we don't parse any dates into Date objects. A JavaScript Date
		// object is actually a DateTime with some arbitrary timezone, and is full
		// of other gotchas. Since all we need is comparisons, we work with dates
		// as yyyy-mm-dd strings instead.

		var runs = $('#run option').map(function(i, el) {
			var run = JSON.parse($(el).attr('data-run'));
			run.optionValue = el.value;
			run.selected = el.selected;
			return [run]; // jQuery.map flattens away one level of arrays.
		}).get();

		function getIndicesFromHash(hash) {
			hash = (hash || '#').substr(1);
			if (!/^\d+:\d{4}:\d{1,2}$/.test(hash)) {
				return null;
			}
			var parts = hash.split(':');
			var runId = parseInt(parts[0]);
			var weekYear = parseInt(parts[1]);
			var weekNumber = parseInt(parts[2]);
			for (var i = 0; i < runs.length; i++) {
				var run = runs[i];
				if (run.id == runId) {
					for (var j = 0; j < run.weeks.length; j++) {
						var week = run.weeks[j];
						if (week.year == weekYear && week.week == weekNumber) {
							var result = {run: i, week: j};
							// console.log('Found indices from hash:', result);
							return result;
						}
					}
				}
			}
			return null;
		}

		// Finds the selected run, and the current week within that, or the
		// first/last week if not started yet or over.
		// Return null if and only if no run was pre-selected on the server.
		function getIndicesFromSelected(today) {
			var result = null;
			$.each(runs, function(i, run) {
				if (!run.selected) {
					return; // continue
				}
				result = {run: i, week: 0}
				$.each(run.weeks, function(j, week) {
					if (week.startDate <= today) {
						result.week = j;
					} else {
						return false; // break
					}
				});
				return false; // break
			});
			// if (result) { console.log('Found indices from selected:', result); }
			return result;
		}

		// Finds the earliest week that isn't over yet.
		function getIndicesFromDate(today) {
			var earliestEndDate = null;
			var result = null;
			$.each(runs, function(i, run) {
				$.each(run.weeks, function(j, week) {
					if (today <= week.endDate && (!earliestEndDate || week.endDate < earliestEndDate)) {
						earliestEndDate = week.endDate;
						result = {run: i, week: j};
					}
				});
			});
			// if (result) { console.log('Found indices from date:', result); }
			return result;
		}

		function getLastIndices() {
			var runIndex = 0;
			var weekIndex = runs[runIndex].weeks.length - 1;
			var result = {run: runIndex, week: weekIndex};
			// console.log('Using last indices:', result);
			return result;
		}

		function zeroPad(value, length) {
			value = '' + value;
			while (value.length < length) {
				value = '0' + value;
			}
			return value;
		}

		function today() {
			var date = new Date();
			return date.getFullYear() + '-' + zeroPad(date.getMonth() + 1, 2) + '-' + zeroPad(date.getDate(), 2);
		}

		function updateWeekMenu() {
			var weekMenu = $('#week-menu');
			weekMenu.addClass('loading');
			var run = runs[indices.run];
			var week = run.weeks[indices.week];
			$.get({
				url: "../getmenu/",
				data: {
					run_id: run.id,
					vc_start_date: run.vcStartDate,
					week_start_date: week.startDate,
					week_end_date: week.endDate,
				},
				dataType: 'html',
			}).done(function(msg) {
				weekMenu.html(msg);
			}).fail(function(jqXHR, textStatus, errorThrown) {
				console.error(errorThrown);
				weekMenu.html('<p class="no-recipes">Er ging iets mis bij het laden van de recepten: ' + textStatus + '</p>');
			}).always(function() {
				weekMenu.removeClass('loading');
			});
		}

		var indices = getIndicesFromHash(window.location.hash) || getIndicesFromSelected(today()) || getIndicesFromDate(today()) || getLastIndices();

		var runPicker = $('#run').selectmenu();
		var weekList = $('#week-list');

		function updateRunPicker() {
			runPicker.val(runs[indices.run].optionValue);
			runPicker.selectmenu('refresh');
		}

		function updateWeekPicker() {
			weekList.empty();
			$.each(runs[indices.run].weeks, function(i, week) {
				// <li class="week-item"><a class="week-link"><span class="week-text">Wk 14</span><span class="year-text">2018</span></a></li>
				var a = $('<a>').attr('href', '#').addClass('week-link');
				a.append($('<span>').addClass('week-text').text('Wk ' + week.week));
				a.append($('<span>').addClass('year-text').text(week.year));
				var li = $('<li>').addClass('week-item');
				if (i == indices.week) {
					li.addClass('selected');
				}
				a.on('click', function(e) {
					e.preventDefault();
					if ($(this).hasClass('selected')) {
						return;
					}
					weekList.find('.selected').removeClass('selected');
					$(this).parent('li').addClass('selected');
					indices.week = i;
					updateHash();
					updateWeekMenu();
				});
				li.append(a);
				weekList.append(li);
			});
		}

		function updateHash() {
			var week = runs[indices.run].weeks[indices.week];
			window.location.hash = '#' + runs[indices.run].id + ':' + week.year + ':' + week.week;
		}

		updateRunPicker();
		updateWeekPicker();
		updateWeekMenu();

		runPicker.on('selectmenuchange', function(event, ui) {
			indices.run = ui.item.index;
			indices.week = 0;
			updateWeekPicker();
			updateHash();
			updateWeekMenu();
		});
	});
});
